import {Component} from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {
    static propTypes = {
        shouldThrowOnError: PropTypes.bool,
        logError: PropTypes.func,
    };

    static defaultProps = {
        shouldThrowOnError: false,
    };

    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }
    // eslint-disable-next-line react/sort-comp, no-unused-vars
    static getDerivedStateFromError(error) {
        return {hasError: true};
    }

    componentDidCatch = (error) => {
        if (this.props.logError) {
            this.props.logError(error);
        }
        if (this.props.shouldThrowOnError) {
            throw error;
        }
    };

    render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
